export default "__VITE_ASSET__Tq1V97t4__"